import {getAccordionAndTabLinks, getSlug} from "../functions/functions";
import {
    AccordionContainerDPC, AccordionDPC,
    AllegatoContainerDPC,
    AllegatoDPC,
    LinksContainerDPC,
    LinksDPC,
    PageContainerDPC,
    PrintButtonDPC,
    TabsetDPC
} from "@dpc-fe/shared";
import moment from "moment";
import React from "react";
import {graphql} from "gatsby";
import {prop, getCategoriaPrimariaEN} from "../functions/functions";
import {buildMenu, findParent} from "@dpc-fe/shared/js/shared-functions";

export default ({data, pageContext}) => {

    const language = '/' + pageContext.lang;
    moment.locale("en");
    const dateFormat = "YYYYMMDD_hhmm";
    const correlazioniTypes = ['comunicato_stampa','notizia','approfondimento','pubblicazione', 'corso', 'pagina', 'sezione'];

    const fotoVideoTypes = ['galleria_foto','galleria_flickr','video'];

    const correlazioni = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria == null || correlazioniTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +getCategoriaPrimariaEN(item.field_categoria_primaria).charAt(0).toUpperCase() + getCategoriaPrimariaEN(item.field_categoria_primaria).replace(/_/g, ' ').slice(1)+'</b>' : '<b>Section</b>') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_MAPPE, item.relationships.field_sottodominio.name)
      }   
    });

    const fotoVideo = data.node.relationships.field_correlazioni.filter(item => fotoVideoTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
      return {
          title: (item.field_categoria_primaria === 'video' ? '<b>Video</b>' : '<b>Photo</b>') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_MAPPE, item.relationships.field_sottodominio.name)
      }   
    });

    const bandoDiGara = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'bando_di_gara').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +getCategoriaPrimariaEN(item.field_categoria_primaria).charAt(0).toUpperCase() + getCategoriaPrimariaEN(item.field_categoria_primaria).replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_MAPPE, item.relationships.field_sottodominio.name)
      }   
    });

    const mappe = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'mappa').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +getCategoriaPrimariaEN(item.field_categoria_primaria).charAt(0).toUpperCase() + getCategoriaPrimariaEN(item.field_categoria_primaria).replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_MAPPE, item.relationships.field_sottodominio.name)
      }   
    });

    const timeline = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'timeline').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +getCategoriaPrimariaEN(item.field_categoria_primaria).charAt(0).toUpperCase() + getCategoriaPrimariaEN(item.field_categoria_primaria).replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_MAPPE, item.relationships.field_sottodominio.name)
      }   
    });

  const normative = data.node.relationships.field_normative.map(item => {
      return {
          title: item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_MAPPE, item.relationships.field_sottodominio.name)
      }
  });

  const linkEsterni = data.node.field_link_esterni ? data.node.field_link_esterni.map(item => {
      return {
          title: item.title,
          titleLinkEsterno: "Val al sito " + item.uri,
          slug: item.uri
      }
  }) : [];
    const tabItems = [{
        iframe: data.node.field_mappa_today,
        title: `Forecast phase of ${moment(data.node.field_data_bollettino, dateFormat)
            .format("DD MMMM YYYY")}`,
        body: data.node.field_descrizione_today?.processed,
        active: moment().isSame(moment(data.node.field_data_bollettino, dateFormat), "day")
    }, {
        iframe: data.node.field_mappa_tomorrow,
        title: `Forecast phase of ${moment(data.node.field_data_bollettino, dateFormat)
            .add(1, "day")
            .format("DD MMMM YYYY")}`,
        body: data.node.field_descrizione_tomorrow?.processed,
        active: moment().isSame(moment(data.node.field_data_bollettino, dateFormat).add(1, "day"), "day")
    }, {
        iframe: data.node.field_mappa_after_tomorrow,
        title: `Forecast phase of ${moment(data.node.field_data_bollettino, dateFormat)
            .add(2, "day")
            .format("DD MMMM YYYY")}`,
        body: data.node.field_descrizione_after_tomorrow?.processed,
        active: moment().isSame(moment(data.node.field_data_bollettino, dateFormat).add(2, "day"), "day")
    }];

    const breadcrumbItem = {
      name: data.node.title,
      slug: data.node.fields && data.node.fields.slug ? data.node.fields.slug : null,
      active: true
  }

    const fullMenuMinisito = buildMenu(pageContext.menuMinisito, pageContext.lang, process.env.ENV, null, data.node.drupal_internal__nid);
    const submenu = findParent(fullMenuMinisito, data.node.drupal_internal__nid);
    const showMenu = !!submenu && (!(Array.isArray(submenu.children) && submenu.children.length <= 0 && !submenu.idParent));

    return (
        <PageContainerDPC isMappe={true}  classeAggiuntivaSubnavbar={"has-header-subnavbar"}
                          menuItems={pageContext.menu}
                          slugTraduzione={data.node.relationships.field_riferimento_traduzione?.fields?.slug}
                          pageId={data.node.drupal_internal__nid}
                          title={data.node.title}
                          env={process.env.ENV}
                          lang={pageContext.lang}
                          domain={process.env.MINISITO_MAPPE_LABEL_EN}
                          subdomainMenuItems={pageContext.menuMinisito}
                          basePathNavbar={process.env.PORTALE_URL}
                          //checkTorna={true}
                          //linkTorna={submenu?.link}
                          //textTorna={submenu?.title}
                          minisiti={prop}
                          breadcrumbItem={!!data.node?.path?.alias ? null : breadcrumbItem}
                          immagineShare={data.node.relationships?.field_immagine_dettaglio ? process.env.MINISITO_MAPPE_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_MAPPE_URL + pageContext.socialImg?.relationships?.image?.localFile?.publicURL}
                          abstractShare={data.node.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
                          slug={process.env.MINISITO_MAPPE_URL + '/' + pageContext.lang + data.node.fields.slug}
                          menuFooterItems={pageContext.menuFooter}
        >
            <div className="container">
                <div className="px-custom">
                    <div className="row">
                        <div className="col-12">
                            <h1>{data.node.title}</h1>
                            <div dangerouslySetInnerHTML={{__html: data.node.body?.processed}}/>
                            <article>

                                <TabsetDPC id="Tabset1" items={tabItems}/>

                                {(data.node.relationships.field_accordion && data.node.relationships.field_accordion.length > 0) &&
                                <AccordionContainerDPC id="1">
                                    {data.node.relationships.field_accordion
                                        .map(node => (
                                            <AccordionDPC
                                                title={node.field_titolo ? node.field_titolo : ''}
                                                body={node.field_testo ? node.field_testo.value : ''}
                                                id={node.drupal_internal__id}
                                                accordionId={"1"}
                                                img={node.relationships.field_immagine}
                                                tabella={node.field_tabella?.processed}
                                                video={node.relationships.field_video}
                                                links={node.relationships ? getAccordionAndTabLinks(node.relationships.field_link_interni, pageContext.lang, process.env.MINISITO_MAPPE) : null}
                                            />))}
                                </AccordionContainerDPC>
                                }


                                <section className="attachments-and-links">
                                    {(Array.isArray(data.node.relationships.field_allegati) &&
                                        data.node.relationships.field_allegati.length > 0) &&
                                    <AllegatoContainerDPC titoloSezione={'Attachments'}>
                                        {
                                            data.node.relationships.field_allegati.map(allegato => (
                                                <AllegatoDPC
                                                  titolo={allegato.field_titolo_esteso}
                                                  descrizione={allegato.relationships?.field_allegato?.description}
                                                  dimension={allegato.relationships?.field_allegato?.filesize}
                                                  slug={allegato.relationships?.field_allegato?.localFile?.publicURL}
                                                  extension={allegato.relationships?.field_allegato?.localFile?.extension}
                                              />
                                            ))
                                        }
                                    </AllegatoContainerDPC>
                                    }
                                    {normative && normative.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Regulations'}>
                                        <LinksDPC links={normative}/>
                                    </LinksContainerDPC>}

                                    {bandoDiGara && bandoDiGara.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Notices and calls for tender'}>
                                        <LinksDPC links={bandoDiGara}/>
                                    </LinksContainerDPC>}

                                    {correlazioni && correlazioni.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Read more'}>
                                        <LinksDPC links={correlazioni}/>
                                    </LinksContainerDPC>}

                                    {fotoVideo && fotoVideo.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Photos and Videos'}>
                                        <LinksDPC links={fotoVideo}/>
                                    </LinksContainerDPC>}                                  

                                    {mappe && mappe.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Maps'}>
                                        <LinksDPC links={mappe}/>
                                    </LinksContainerDPC>}

                                    {timeline && timeline.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Timeline'}>
                                        <LinksDPC links={timeline}/>
                                    </LinksContainerDPC>}
                                    {linkEsterni && linkEsterni.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'External links'}>
                                    	<LinksDPC links={linkEsterni}/>
                                    </LinksContainerDPC>}
                                </section>
                                <PrintButtonDPC/>

                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </PageContainerDPC>
    )
}

export const query = graphql`
query($slug: String!) {
  node: nodeBollettinoVigilanza (fields: { slug: { eq: $slug } }) {
    field_titolo_esteso
    field_categoria_primaria
    title

    body {
        value
        processed
    }
    fields {
      slug
    }
    drupal_internal__nid
    field_link_esterni {
      title
      uri
    }
    field_data_bollettino
    field_mappa_today {
      uri
      title
    }
    field_mappa_tomorrow {
      title
      uri
    }
    field_mappa_after_tomorrow {
      title
      uri
    }
    field_descrizione_today {
      value
      processed
    }
    field_descrizione_tomorrow {
      processed
      value
    }
    field_descrizione_after_tomorrow {
      processed
      value
    }
    relationships {
      field_sottodominio {
        name
      }
      field_immagine_dettaglio {
        field_alt
        field_didascalia
        field_titolo_esteso
        relationships {
          image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                fluid(maxWidth: 1100) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
        }
        }
      }
        field_riferimento_traduzione {
            fields {
                slug
            }
        }
        field_allegati {
            title
            field_titolo_esteso
            relationships {
              field_allegato {
                filesize
                localFile {
                  publicURL
                  extension
                }
                filename
              }
            }
        }
        field_correlazioni {
                    ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
      }
        field_normative {
            ...normativaFragment
        }
        field_accordion {
          field_titolo
          field_tabella {
            processed
          }
          field_testo {
            processed
            value
          }
          relationships {
            field_immagine {
              field_alt
              field_didascalia
              relationships {
                image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                      fluid(maxWidth: 1100) {
                        ...GatsbyImageSharpFluid_noBase64
                      }
                    }
                  }
                }
              }
            }
            field_link_interni{
                          ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
            }
            field_video {
              field_video {
                title
                uri
              }
              field_didascalia
              title
              field_titolo_esteso
            }
          }
          drupal_internal__id
        }
    }
  },
  meteoIdro: nodeSezioneAllertaMeteoIdro (field_codice_lingua: {eq: true}) {
      title
      field_titolo_esteso
      fields {
        slug
      }
      drupal_internal__nid
  }
}`;
